import { FC, useEffect, useMemo, useState } from "react";
import { StyledImageComponentProps } from "./StyledImageComponentProps";

const StyledImage: FC<StyledImageComponentProps> = (props) => {
  const { type, rootApiPath, fallBack } = props;
  const [imageUrl, setImageUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { defaultUrl, apiPath } = useMemo(() => GetImagePropertiesForType({ type, rootApiPath, fallBack }), [type, rootApiPath, fallBack]);

  useEffect(() => {
    const fetchImageForProperties = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(apiPath);
        if (!response.ok) {
          setImageUrl(defaultUrl);
          return;
        }
        setImageUrl(response.url);
      } catch {
        setImageUrl(defaultUrl);
      } finally {
        setIsLoading(false);
      }
    };

    if (apiPath) {
      fetchImageForProperties();
    } else {
      setImageUrl(defaultUrl);
      setIsLoading(false);
    }
  }, [apiPath, defaultUrl]);

  const renderContent = () => {
    if (isLoading) {
      return props.loader || <div data-testid={`styled-image-${props.type}-default-loader`}></div>;
    }

    if (!imageUrl) {
      return <div data-testid={`styled-image-${props.type}-no-source`}></div>;
    }

    return (
      <img
        data-testid={`styled-image-${props.type}`}
        className={props.className || "styled-image"}
        src={imageUrl}
        alt={props.alt || props.type}
        width={props.width}
        height={props.height}
        loading="lazy"
      />
    );
  };

  return <>{renderContent()}</>;
};

const GetImagePropertiesForType = (props: StyledImageComponentProps) => {
  switch (props.type) {
    case "background":
      return {
        defaultUrl: props?.fallBack ?? "/background.png",
        apiPath: `${props.rootApiPath ?? ""}/v1/style/assets/Background/file`,
      };
    case "logo":
      return {
        defaultUrl: props?.fallBack ?? "/logo.svg",
        apiPath: `${props.rootApiPath ?? ""}/v1/style/assets/Logo/file`,
      };
    case "emblem":
      return {
        defaultUrl: props?.fallBack ?? "/emblem.svg",
        apiPath: `${props.rootApiPath ?? ""}/v1/style/assets/Emblem/file`,
      };
    default:
      return {
        defaultUrl: "",
        apiPath: "",
      };
  }
};

export { StyledImage };
